import request from '../services/request';

export const getTiers = () => request.get('/paid-tiers');
export const downgradeSubscription = (tier, interval) => request.post(`/paid-tiers/downgrade?tier=${tier}&interval=${interval}`);
export const downgradeSubscriptionCancel = () => request.post('/paid-tiers/downgrade/cancel');
